import { render, staticRenderFns } from "./affairs.vue?vue&type=template&id=d7370baa&scoped=true&"
import script from "./affairs.vue?vue&type=script&lang=js&"
export * from "./affairs.vue?vue&type=script&lang=js&"
import style0 from "./affairs.vue?vue&type=style&index=0&id=d7370baa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7370baa",
  null
  
)

export default component.exports